import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import EntityManager from '../../entityManagement/components/EntityManager';
import { connectPagedEntityManager } from '../../entityManagement';
import FileAddForm from './FileAddForm';
import FileDeleteConfirmationDialog from './FileDeleteConfirmationDialog';
import FilesTable from './FilesTable';

const FilesManager = EntityManager({
    Title: <LocalizedText textKey={TextKey.FilePlural} />,
    Table: FilesTable,
    AddForm: FileAddForm,
    DeleteDialog: FileDeleteConfirmationDialog,
});

export default connectPagedEntityManager(FilesManager);
